var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.62512C19 7.39312 18.954 6.17212 18.862 4.96312C18.7912 4.00527 18.3787 3.10472 17.6996 2.42557C17.0204 1.74642 16.1199 1.33388 15.162 1.26312C12.7241 1.0792 10.2759 1.0792 7.838 1.26312C6.88015 1.33388 5.9796 1.74642 5.30045 2.42557C4.6213 3.10472 4.20876 4.00527 4.138 4.96312C4.121 5.18312 4.106 5.40412 4.092 5.62512M19 8.62512L22 5.62512M19 8.62512L16 5.62512M4 8.62512C4 9.85712 4.046 11.0781 4.138 12.2871C4.20876 13.245 4.6213 14.1455 5.30045 14.8247C5.9796 15.5038 6.88015 15.9164 7.838 15.9871C10.2759 16.1711 12.7241 16.1711 15.162 15.9871C16.1199 15.9164 17.0204 15.5038 17.6996 14.8247C18.3787 14.1455 18.7912 13.245 18.862 12.2871C18.879 12.0671 18.894 11.8461 18.908 11.6251M4 8.62512L7 11.6251M4 8.62512L1 11.6251",
    stroke: "#798CAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepost);
export default __webpack_public_path__ + "static/media/repost.fce1a895d9e8d64dc77da2b0e31cec3b.svg";
export { ForwardRef as ReactComponent };